<template>
  <v-card
    flat
    class="card-style"
  >
    <v-card-title
      v-if="title"
      class="text-accent"
    >
      <h3>{{ title }}</h3>
    </v-card-title>
    <v-divider v-if="title" />
    <v-card-text :class="{'pa-3': $vuetify.display.xsOnly, 'pa-4': $vuetify.display.smAndUp}">
      <slot />
    </v-card-text>

    <template v-if="$slots.actions">
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <slot name="actions" />
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: ''
      }
    },
    data: () => ({}),
    methods: {}
  }
</script>
